import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "phone", "firstName", "lastName"]
  static values = { url: String }

  search(event) {
    const query = event.target.value
    if (!query) return

    fetch(`${this.urlValue}?query=${encodeURIComponent(query)}`, {
      headers: {
        "Accept": "application/json"
      }
    })
    .then(response => {
      if (response.ok) {
        return response.json()
      } else {
        throw new Error("Not found")
      }
    })
    .then(data => {
      this.firstNameTarget.value = data.first_name || ""
      this.lastNameTarget.value = data.last_name || ""
      if (data.email && this.emailTarget.value !== data.email) this.emailTarget.value = data.email
      if (data.phone_number && this.phoneTarget.value !== data.phone_number) this.phoneTarget.value = data.phone_number
    })
    .catch(error => {
      // User not found, do nothing (allow creating new user)
    })
  }
}
